module.exports = __webpack_public_path__ + "img/dashboard_grey.c93455a4.svg";